import template from './visual-divider.jade';

export default angular
  .module('cian.addForm.aboutBuildingDivider', ['cian.addForm.visualDivider'])
  .directive('cianAfAboutBuildingVisualDivider', () => ({
    template,
  })).name;
